import { useCallback } from 'react'
import { Box } from '@mui/material'
import { useBookingContext } from '@providers/booking'
import { SpeciesButtons } from 'components-ui'
import type { TSpecieButtonsProps } from './pet_search_simple.d'
import { LocationSpeciesClientDto } from 'service-api/src/types'

export const BookingSpeciesButtons = ({ group }: TSpecieButtonsProps) => {
  const bookingCtx = useBookingContext()
  const onSelectSpecie = useCallback(
    (specie: LocationSpeciesClientDto) =>
      bookingCtx.dispatch({
        type: 'SET_PET_GROUP_SPECIE',
        payload: { groupIdx: group, specieId: specie.id },
      }),
    [bookingCtx, group]
  )

  const { groups } = bookingCtx.state
  const { species, booking } = bookingCtx.state.config

  if (!species) {
    return null
  }

  const speciesAvailable =
    (booking?.species?.length || 0) > 0
      ? species.filter((s) => booking!.species!.findIndex((sp) => sp.text === s.id && sp.available) >= 0)
      : species

  return (
    <Box>
      <SpeciesButtons species={speciesAvailable} selected={groups[group]?.specieId} onSelect={onSelectSpecie} />
    </Box>
  )
}
